var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn-toggle',{attrs:{"rounded":"","value":_vm.contractType},on:{"change":_vm.handleChangeContractType}},[_c('v-btn',{attrs:{"small":"","value":"sale"}},[_vm._v("Venta")]),_c('v-btn',{attrs:{"small":"","value":"rent"}},[_vm._v("Renta")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }